import { useEffect, useState } from 'react'
import { Airport } from './airports/Airport'
import { get } from './rest-utils'
import { useAuthenticator } from '@aws-amplify/ui-react'

const useAirports = () => {
  const [airports, setAirports] = useState<Airport[] | undefined>(undefined)
  const [airportsLoadingError, setAirportsLoadingError] = useState<boolean>(false)

  const { user } = useAuthenticator((context) => [context.user])

  useEffect(() => {
    console.log('user logged in for getting airports: ', user)
    if (!user || !user.getSignInUserSession()) {
      setAirports(undefined)

      return
    }

    get<Airport[]>('airports')
      .then((airportsResult) => {
        setAirportsLoadingError(false)
        setAirports(airportsResult)
      })
      .catch((err) => {
        console.log('Error while getting airports: ', err)
        setAirportsLoadingError(true)
      })
  }, [user])

  return { airports, airportsLoadingError }
}

export default useAirports
